import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { LogAuditoriaQuery } from 'app/query/log-auditoria-query';
import { map, take } from 'rxjs/operators';
import { LogAuditoriaGraphql } from 'app/model/log-auditoria';

@Injectable({
  providedIn: 'root'
})
export class GraphqlLogAuditoriaService {

  constructor(
    private apollo: Apollo) { }

    getDatosAnalitica(jsonString: string) {
    return (this.apollo.watchQuery<LogAuditoriaGraphql>({
      query: LogAuditoriaQuery.DATOS_ANALITICA_TYPE_QUERY,
      variables: {
        jsonString: jsonString
      }
    }).valueChanges.pipe(map(res => { return res.data.getDatosAnalitica }))).pipe(take(1))
  }
}
